import React, { FC } from 'react';

import { PolicyResponse } from '@ariksa/abac/api';
import { HStack, Stack, Text } from '@chakra-ui/react';
import { colorOpacity, customTheme } from 'theme';

import {
  DetailsIdentifier,
  renderStackedCloudNameAndIcon,
  StackedHeader,
  WithResourceIcon,
} from 'components/DataDisplay';
import { IconTypes, PolicyOldIcon } from 'components/Icons';
import { Drawer } from 'components/Overlay';
import { resolveDefaultMaskOption } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/maskOptions';
import { DataPolicyRoles } from 'containers/Jit/MaskingPolicies/Components/Drawer/DataPolicyRoles';

interface IDataPolicyDrawer {
  isOpen: boolean;
  onClose: () => void;
  row: PolicyResponse;
}

export const DataPolicyDrawer: FC<IDataPolicyDrawer> = props => {
  const { isOpen, onClose, row } = props;

  return (
    <Drawer
      isOpen={isOpen}
      onClose={onClose}
      header={
        <StackedHeader
          upper={row?.name}
          lower="Data Policy"
          icon={<PolicyOldIcon p={0.5} />}
          color={customTheme.colors.primary}
          bg={colorOpacity(customTheme.colors.primary, 0.2)}
          useCustomColor
        />
      }
      body={
        <Stack spacing={10} h="full">
          <HStack align="flex-start">
            <DetailsIdentifier
              label="Description"
              value={
                <Text noOfLines={2} whiteSpace="wrap">
                  {row.description}
                </Text>
              }
              w="60%"
              isInline={false}
              spacing={0}
            />
            <Stack>
              <DetailsIdentifier
                label="Cloud"
                value={renderStackedCloudNameAndIcon('snowflake', true)}
              />
              <DetailsIdentifier
                label="Default Masking"
                value={
                  <WithResourceIcon
                    resourceType={IconTypes.Mask}
                    color={customTheme.colors.blue['300']}
                    iconStyles={{ w: 7, h: 7, p: 1 }}
                  >
                    {
                      resolveDefaultMaskOption(
                        row?.policy_json?.default_mask_config?.method,
                      ).label
                    }
                  </WithResourceIcon>
                }
              />
            </Stack>
          </HStack>
          <DataPolicyRoles row={row} />
        </Stack>
      }
      styles={{ content: { maxW: '1200px' } }}
    />
  );
};
